import {useMutation, useQuery} from 'admin/lib/apollo'
import {GET_USER, CREATE_USER, UPDATE_USER, SEND_USER_INVITATION} from 'admin/gql/User.gql'
import clearCache from './clearCache'

export default (organisationId, userId) => {
  const {data: {user = {}} = {}, error: getError} = useQuery(GET_USER, {
    variables: {organisationId, userId},
    skip: !userId
  })

  const [create, {error: createError}] = useMutation(CREATE_USER, {
    variables: {organisationId},
    flash: 'User created',
    update: cache => clearCache({users: {organisationId}})(cache)
  })

  const [update, {error: updateError}] = useMutation(UPDATE_USER, {
    variables: {organisationId, userId},
    flash: 'User updated'
  })

  const [sendInvitation, {error: sendInvitationError}] = useMutation(SEND_USER_INVITATION, {
    variables: {organisationId, userId},
    flash: 'Invitation sent'
  })

  return {
    user,
    errors: getError || createError || updateError || sendInvitationError || {},
    create,
    update,
    sendInvitation
  }
}
